import React, { Component } from 'react'
import styled from 'styled-components'
import { GREEN50, WHITE, BLACK, YELLOW254 } from '../../../common/constants.js'

const clientWidth = window.screen.width;
const clientHeight = window.screen.height;

class OutpatientAppointment extends Component {
  render() {
    return (
      <RootView>
        <div style={{
          width: clientWidth,
          height: 200,
          backgroundImage: 'url(' + require('./images/bg-group.png') + ')',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}>
          <TitleView>
            <TitleText>糖尿病共同照护</TitleText>
            <TitleText>门诊预约</TitleText>
          </TitleView>
        </div>
        <BgImage src={require('./images/bg-welcome.png')} />
      </RootView>
    )
  }

}

export default OutpatientAppointment

const RootView = styled.div`
    background-color: white;
    flex-direction:column;
    width:100%;
    height:100%;
  `
const BgImage = styled.img`
    width:100%;
  `
const TitleView = styled.div`
  flex-direction: column;
  align-items: center;
  padding-top:65px;
`
const TitleText = styled.div`
     font-size: 30px;
     margin-left:40px;
     margin-right:40px;
     padding-top:5px;
     font-weight: bold;
     color: ${WHITE};
     text-align: center;
   `  



// WEBPACK FOOTER //
// ./src/modules/appointment/components/outpatientAppointment.js